import { z } from "zod";

export const SiteDtoSchema = z.object({
  id: z.string().uuid(),
  shopId: z.string(),
  url: z.string(),
  order: z.coerce.number(),
  enabled: z.boolean(),
  maxProductCount: z.coerce.number(),
  interval: z.coerce.number(),
  metaInterval: z.coerce.number(),
  maxRetries: z.coerce.number(),
  siteType: z.string(),
  siteSource: z.string(),
  lastScrapeTs: z.coerce.number(),
  lastMetaTs: z.coerce.number(),
  timesFailed: z.coerce.number(),
  description: z.string().nullable(),
  estimatedMonthlySales: z.number().nullish(),
  platformRank: z.number().nullish(),
  platformPercentile: z.number().nullish(),
});

export type SiteDto = z.infer<typeof SiteDtoSchema>;
